import * as tslib_1 from "tslib";
import React from 'react';
import { useTransition, animated } from 'react-spring';
import NotificationContent from '../NotificationContent';
import s from '../../Notifications.scss';
import styleVars from '../../../styles/variables.scss';
var transitionOptions = {
    unique: true,
    reset: true,
    config: {
        duration: 200,
    },
    from: {
        opacity: 0,
        transform: "translate3d(0, -" + styleVars['system-notification-height'] + ", 0)",
        height: 0,
    },
    enter: {
        opacity: 1,
        transform: 'translate3d(0, 0, 0)',
        height: 'auto',
    },
    leave: {
        opacity: 0,
        transform: "translate3d(0, -" + styleVars['system-notification-height'] + ", 0)",
        height: 0,
    },
};
var getNotificationKey = function (item) { return item && item.id; };
var NotificationAnimator = function (_a) {
    var queue = _a.queue, notificationProps = _a.notificationProps;
    var transitions = useTransition(queue.slice(0, 1), getNotificationKey, transitionOptions);
    return (React.createElement(React.Fragment, null, transitions.map(function (_a) {
        var style = _a.props, key = _a.key, item = _a.item;
        return (React.createElement(animated.div, { key: key, className: s['animator'], style: style },
            React.createElement(NotificationContent, tslib_1.__assign({ notification: item }, notificationProps))));
    })));
};
NotificationAnimator.displayName = 'NotificationAnimator';
export default NotificationAnimator;
//# sourceMappingURL=NotificationAnimator.js.map